// extracted by mini-css-extract-plugin
export default {"brandPromo":"GG-z","carousel":"HG-z"};